import { type VideoItem } from '@gx-admin/hooks/web/useVideo'
import { isBuild, typeViteEnv } from '@/utils/env'
import { getMediaInfos, generateVidoePicture, isMobileDevice } from '@/utils/util'
import VideoEvents from './event'
import VideoTemplate from './template'

let id = 0

async function getVideoCover(url: string) {
  const { play } = await getMediaInfos({ url, fileType: '3' })

  if (play) return await generateVidoePicture(url)
  return ''
}

export type VideoPlayerOptions = {
  config: {
    key: number;
    width: number;
    height: number;
    record: VideoItem;
    isGiveWidth: boolean;
  }
  callBackFun: {
    play: () => void;
    pointError: () => void;
    fullScreen?: () => void;
    ready: (width: number, height: number, callBack: (height: number) => void) => void;
    videoEnd: (current: number, duration: number) => void;
    fristPlay: (duration: number) => void;
    closeFixModal: (id?: string) => void;
    continueNetwork: () => void;
    pauseOhterDp: (currentId: string) => void;
  };
}

export default class VideoEnPlayer {
  id: number;
  player: Aliplayer;
  poster: string;
  originPoster: string;
  isDestroy: boolean;
  options: VideoPlayerOptions['config'];
  callBackFun: VideoPlayerOptions['callBackFun'];
  container: HTMLElement;
  template: VideoTemplate;
  events: VideoEvents;

  constructor(options: VideoPlayerOptions) {
    this.options = options.config
    this.callBackFun = options.callBackFun

    this.id = ++id
    this.player = null
    this.poster = ''
    this.originPoster = ''
    this.isDestroy = false
    this.container = document.querySelector(`#video-player-${this.options.key}`)

    this.initOhtersPlayer()

    this.template = new VideoTemplate(this)
    this.events = new VideoEvents(this)
  }

  get proxy() {
    return this.events.proxy
  }

  get query() {
    return this.template.query
  }

  async initOhtersPlayer() {
    const domId = this.container.getAttribute('id')
    const url = this.options.record.url

    const publicImageUrl = isBuild() ? typeViteEnv('VITE_OSS_BUILD_URL') + 'resource/image' : '/resource/image'

    this.poster = this.options.record.poster || ''
    this.originPoster = this.options.record.poster || ''

    const cdnUrl = [
      'cdnpdcontent.aikan.pdnews.cn',
      'cdnpdjdcontentuat.aikan.pdnews.cn',
      'cdnpdcontentsit.aikan.pdnews.cn',
      'cdnpdcontentuat.aikan.pdnews.cn',
      'cdnjdcontent.aikan.pdnews.cn',
      'jdcontentcdn.aikan.pdnews.cn',
      'sitjdcontentcdn.aikan.pdnews.cn',
      'uatjdcdncollect.aikan.pdnews.cn',
      'uatjdcontentcdn.aikan.pdnews.cn'
    ]

    if (!this.poster && cdnUrl.some(el => url.includes(el))) {
      this.poster = `${url}?x-oss-process=video/snapshot,t_0,f_jpg`
      this.originPoster = `${url}?x-oss-process=video/snapshot,t_0,f_jpg`
    }

    if (!this.poster && !isMobileDevice()) {
      const cover =  await getVideoCover(this.options.record.url as string)
      if (cover) {
        this.poster = cover
        this.originPoster = cover
      }
    }

    if (!this.poster) {
      this.poster = `${publicImageUrl}/placeholdLogo.svg`
    }

    this.player = new Aliplayer({
      id: domId,
      cover: this.poster,
      language: 'en-us',
      autoplay: false,
      x5_type: true,
      source: url
    })
  }

  destroy() {
    this.isDestroy = true
    this.events.destroy()

    if (this.player) {
      this.player.dispose()
    }

    this.player = null
  }
}
